export default __webpack_public_path__ + "static/media/karta.3e0e33e9.svg";